"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getValues = getValues;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _getInputValues = require("../get-input-values");
/**
 * No need to constantly track values in a ref or state. We can just retrieve
 * values when needed from the input nodes themselves, i.e. source of truth.
 * @param   {HTMLFormElement}               formElement
 * @param   {Map<HTMLInputElement,object>}  inputsMap
 * @returns {object}
 */
function getValues(formElement, inputsMap) {
  const values = {};
  (0, _forEach.default)(inputsMap).call(inputsMap, (inputState, inputElement) => {
    // value, key
    values[inputElement.name] = (0, _getInputValues.getInputValues)(formElement, inputElement.name);
  });
  return values;
}